import { BulkMessageSendOptionInput, UnitEnum } from "@/__generated__/graphql";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CardOption } from "@/components/ui/CardOption";
import { FormValues } from "../types";
import { DateTimeScheduler } from "./DateTimeScheduler";

interface OneTimeSendProps {
  timeZone?: string;
  defaultMonth?: Date;
}

export function OneTimeSend({ timeZone, defaultMonth }: OneTimeSendProps) {
  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.composeMessage",
  });

  const { setValue, getValues } = useFormContext<FormValues>();

  const [selected, setSelected] = useState<string | undefined>(
    defaultValue(getValues("sendOption")),
  );

  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => {
            setSelected("sendNow");
            setValue(
              "sendOption",
              { sendNow: UnitEnum.Unit },
              {
                shouldTouch: true,
                shouldDirty: true,
                shouldValidate: true,
              },
            );
          }}
        >
          <CardOption
            selected={selected === "sendNow"}
            title={t("oneTimeSend.sendNow")}
            data-testid="one-time-send-now"
          />
        </button>
        <button
          type="button"
          onClick={() => {
            setValue("sendOption.sendLater.startSendingAt", undefined, {
              shouldTouch: true,
              shouldDirty: true,
              shouldValidate: true,
            });
            setSelected("sendLater");
          }}
        >
          <CardOption
            selected={selected === "sendLater"}
            title={t("oneTimeSend.sendLater")}
            data-testid="one-time-send-later"
          />
        </button>
      </div>
      {selected === "sendLater" ? (
        <DateTimeScheduler
          timeZone={timeZone}
          label={t("inputs.date.scheduleStartDate")}
          name={"sendOption.sendLater.startSendingAt"}
          defaultMonth={defaultMonth}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

function defaultValue(sendOption?: BulkMessageSendOptionInput) {
  if (sendOption?.sendNow) {
    return "sendNow";
  } else if (sendOption?.sendLater) {
    return "sendLater";
  } else {
    return;
  }
}
